import { useEffect, useState } from "react";
import styles from "../addBooking.module.css";
import { Delete } from "@mui/icons-material";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import axios from "axios";
import { authData } from "../../../../components/GetAuth";
import { NumericFormat } from "react-number-format";

// Shop items are one flat list (no categories). "Other" (id 0) is a one-off item typed in by hand.
// category_id mirrors item_id so the rest of the wizard can keep treating 0 as "Other".
const DeliveryProductComponent = ({ fields, append, errors, control, setValue, register, clearErrors, watch, cngProductVal, delItems }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [itemList, setItemList] = useState([]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "v1/delivery-product-dd-list", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`
            }
        }).then((response) => {
            if (response.data.status === "SUCCESS") {
                setItemList(response.data.data || []);
            }
        });
    }, [API_TOKEN]);

    // Saved orders keep an item even if it is no longer offered
    const lines = watch("delivery_products") || [];
    const options = [...itemList];
    lines.forEach((line) => {
        const id = Number(line?.item_id);
        if (id > 0 && !options.some((o) => o.id === id)) {
            options.push({ id, title: line?.item_name || "Item", amount: line?.price, saved: true });
        }
    });

    const stockText = (val) => {
        if (parseInt(val?.track_stock) !== 1) return "";
        const qty = parseInt(val?.stock_qty) || 0;
        return qty > 0 ? ` (${qty} in stock)` : " (out of stock)";
    };

    return (<div className={`${styles.BookADelivery}`}>
        <div className={`${styles.BookADeliveryCardArea}`}>
            {fields.map((item, index) => {
                const isOther = watch(`delivery_products[${index}].category_id`) === 0;
                return (<div className={`${styles.BookDeliveryCard}`} key={item.id}>
                    <div className={`${styles.BookDeliveryCardUnder}`}>
                        <div className={`${styles.BookDeliveryCardUnderRow}`}>
                            <div className={styles.ProductField}>
                                <FormControl fullWidth>
                                    <InputLabel>Item*</InputLabel>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`delivery_products[${index}].category_id`, { validate: (v) => v !== "" && v !== null && v !== undefined })}
                                        render={({ field }) => (<Select
                                            {...field}
                                            label="Item*"
                                            onChange={(e) => {
                                                field.onChange(e);
                                                const id = e.target.value;
                                                setValue(`delivery_products[${index}].item_id`, id);
                                                setValue(`delivery_products[${index}].is_item`, true);
                                                setValue(`delivery_products[${index}].quantity`, 1);
                                                if (id === 0) {
                                                    setValue(`delivery_products[${index}].item_name`, "");
                                                    setValue(`delivery_products[${index}].total`, "");
                                                    setValue(`delivery_products[${index}].price`, "");
                                                } else {
                                                    const selected = options.find((o) => o.id === id);
                                                    setValue(`delivery_products[${index}].item_name`, selected?.title || "");
                                                    setValue(`delivery_products[${index}].total`, selected?.amount);
                                                    setValue(`delivery_products[${index}].price`, selected?.amount);
                                                }
                                                clearErrors();
                                                cngProductVal();
                                            }}
                                        >
                                            {options.map((val) => (<MenuItem key={val.id} value={val.id}>{val.title}{stockText(val)}</MenuItem>))}
                                            <MenuItem value={0}>Other</MenuItem>
                                        </Select>)}
                                    />
                                </FormControl>
                                {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.category_id && (<p className={`${styles.ErrorM}`}>Please select an item</p>)}
                            </div>

                            <div className={styles.ProductField}>
                                {isOther && (<div className={`FormHalfGroup`}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`delivery_products[${index}].item_name`, { required: true })}
                                        render={({ field }) => (<TextField
                                            {...field}
                                            label="Item name*"
                                            fullWidth
                                            variant="outlined"
                                        />)}
                                    />
                                    {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.item_name && (<p className={`${styles.ErrorM}`}>Please enter the item</p>)}
                                </div>)}
                            </div>

                            <div className={styles.ProductFieldDim}>
                                <Controller
                                    key={item.id}
                                    control={control}
                                    {...register(`delivery_products[${index}].quantity`, { required: true })}
                                    render={({ field }) => (<NumericFormat
                                        {...field}
                                        label="Quantity*"
                                        fullWidth
                                        variant="outlined"
                                        customInput={TextField}
                                        allowLeadingZeros={false}
                                        allowNegative={false}
                                        decimalScale={0}
                                        fixedDecimalScale
                                        onChange={(e) => {
                                            field.onChange(e);

                                            if (watch(`delivery_products[${index}].category_id`) !== 0) {
                                                let priceAmnt = watch(`delivery_products[${index}].price`);
                                                let quantityAmnt = parseInt(e.target.value);
                                                if (quantityAmnt > 0 && !isNaN(quantityAmnt)) {
                                                    setValue(`delivery_products[${index}].total`, priceAmnt * quantityAmnt);
                                                }
                                            }

                                            cngProductVal();
                                        }}
                                    />)}
                                />
                                {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.quantity && (<p className={`${styles.ErrorM}`}>Please enter quantity</p>)}
                            </div>

                            <div className={styles.ProductFieldDim}>
                                <Controller
                                    key={item.id}
                                    control={control}
                                    {...register(`delivery_products[${index}].total`, { required: true })}
                                    render={({ field }) => (<NumericFormat
                                        {...field}
                                        label="Total*"
                                        variant="outlined"
                                        fullWidth
                                        customInput={TextField}
                                        allowLeadingZeros={false}
                                        allowNegative={false}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        onChange={(e) => {
                                            field.onChange(e);
                                            cngProductVal();
                                        }}
                                    />)}
                                />
                                {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.total && (<p className={`${styles.ErrorM}`}>Please enter total amount</p>)}
                            </div>
                        </div>
                    </div>

                    <button className={`${styles.CardTrashBU}`} type="button" onClick={(e) => { delItems(index); }}><Delete /></button>
                </div>);
            })}

            <button className={`${styles.HomeBU}`} type="button" onClick={() => { append({ category_id: "", item_id: "", item_name: "", total: "", quantity: "", price: "", is_item: true }); }}>Add Items</button>
        </div>
    </div >);
}

export default DeliveryProductComponent;